import { render, staticRenderFns } from "./longp1.vue?vue&type=template&id=08a01717&scoped=true&"
import script from "./longp1.vue?vue&type=script&lang=js&"
export * from "./longp1.vue?vue&type=script&lang=js&"
import style0 from "./longp1.vue?vue&type=style&index=0&id=08a01717&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a01717",
  null
  
)

export default component.exports